







import * as $ from 'jquery'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {

	@Prop({ default: true })
	readonly closable!: boolean

	@Prop()
	readonly onApprove?: (el: HTMLElement) => boolean

	@Prop()
	readonly onDeny?: (el: HTMLElement) => boolean

	@Prop({ default: 'scale' })
	readonly transition!: 'scale'

	mounted(): void {

		const options: SemanticUI.ModalOptions = {
			...{
				onApprove: this.onApprove,
				onHidden: () => this.$emit('hidden'),
				onShow: () => this.$emit('show'),
				onVisible: () => this.$emit('visible'),
			},
		}

		$(this.$el)
			.modal('setting', 'closable', this.closable)
			.modal('setting', 'transition', this.transition)
			.modal(options)
	}

	hide(): void {

		$(this.$el).modal('hide')
	}

	show(): void {

		$(this.$el).modal('show')
	}

}

